import { useState } from 'react'

import { IPwaContext, PwaContext } from './PwaContext'

export const PwaContextProvider = (props: any) => {
  const [displayHeader, setDisplayHeader] = useState<boolean>(true)
  const [displayFooter, setDisplayFooter] = useState<boolean>(true)

  const hideHeader = () => setDisplayHeader(false)

  const showHeader = () => setDisplayHeader(true)

  const hideFooter = () => setDisplayFooter(false)
  const showFooter = () => setDisplayFooter(true)

  const context: IPwaContext = {
    header: {
      display: displayHeader,
      hide: hideHeader,
      show: showHeader,
    },
    footer: {
      display: displayFooter,
      hide: hideFooter,
      show: showFooter,
    },
  }

  return (
    <PwaContext.Provider value={context}>{props.children}</PwaContext.Provider>
  )
}
